import { render, staticRenderFns } from "./video-player-playlist.vue?vue&type=template&id=6450a8f5&lang=pug"
import script from "./video-player-playlist.vue?vue&type=script&lang=js"
export * from "./video-player-playlist.vue?vue&type=script&lang=js"
import style0 from "./video-player-playlist.vue?vue&type=style&index=0&id=6450a8f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports